module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"report":"Rapport","close":"Sluiten"},"en-BE":{"report":"Report","close":"Close"},"fr-BE":{"report":"Rapport","close":"Fermer"}}')
  delete Component.options._Ctor
}
